module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayChannel === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayChannel) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    staticStyle: {
      "font-size": "18px"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-television fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.channelIndex + 1) + ":" + _vm._s(_vm.actualBundle.channels[_vm.channelIndex].ReferenceName))]), _vm._v(" "), (_vm.flagDisplayPowerBar && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayEnable && _vm.thisChannelAsDeviceFlag) ? _c('div', {
    staticClass: "row"
  }, [_c('hr'), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarData5Min
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_001H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_004H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_006H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_012H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_024H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_072H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_168H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_336H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_720H
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.attributesDisplayFlag) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.actualBundle.channels[_vm.channelIndex].Attributes), function(attribute, index) {
    return _c('div', [(_vm.actualBundle.channels[_vm.channelIndex].Attributes[index] != 'ND') ? _c('div', {
      staticClass: "col-xm-6 col-sm-4 col-md-2"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-tag fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.actualBundle.channels[_vm.channelIndex].Attributes[index]))])]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayChannel) ? _c('div', {
    staticClass: "block-content"
  }, [(_vm.flagChannelDataIsLoading) ? _c('spinner') : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [(true) ? _c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h3', {
    staticClass: "font-w300 push measurement-graph-row__title"
  }, [_c('img', {
    staticClass: "measurement-graph-row__icon",
    attrs: {
      "width": "80px",
      "src": _vm._f("s3Image")(("appliances/" + (_vm.actualBundle.channels[_vm.channelIndex].ChannelData.channelInfo.iconFile))),
      "alt": ""
    }
  }), _vm._v("\n                              " + _vm._s(_vm.actualBundle.channels[_vm.channelIndex].ChannelData.channelInfo.channelName) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [(_vm.thisChannelAsDeviceFlag) ? _c('div', {
    staticClass: "form-group align-right"
  }, [_c('label', [_vm._v("Online")]), _vm._v(" "), (_vm.actualBundle.channels[_vm.channelIndex].ChannelData.deviceOnline) ? _c('i', {
    staticClass: "fa fa-toggle-on fa-2x"
  }) : _c('i', {
    staticClass: "fa fa-toggle-off fa-2x"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group align-right"
  }, [(_vm.actualBundle.bundleRights.realTimeMeasurementPanel) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.loadCloudLive()
      }
    }
  }, [(_vm.flagCloudLiveIsActivating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('i', {
    staticClass: "fa fa-cloud-download fa-1x push-15-r "
  }), _vm._v("Cloud Live")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_vm._v("\n                                  " + _vm._s(_vm.actualBundle.channels[_vm.channelIndex].ChannelData.channelInfo.description) + "\n                                ")])]), _vm._v(" "), (_vm.actualBundleIsDefaultBundle == false) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.labelAddress[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_vm._v("\n                                  " + _vm._s(_vm.actualBundle.channels[_vm.channelIndex].ChannelData.address) + "\n                                ")])]) : _vm._e()]), _vm._v(" "), (_vm.actualBundleIsDefaultBundle == false && _vm.actualBundle.bundle_configuration.channelDisplayOptions.displayChannelLocalizationFlag) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('Gmap-Map', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "zoom": 8,
      "center": _vm.center
    }
  }, _vm._l((_vm.markers), function(marker, index) {
    return _c('Gmap-Marker', {
      key: index,
      attrs: {
        "position": marker.position,
        "label": marker.label,
        "draggable": false
      }
    })
  }), 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.flagDisplayGraph) ? _c('div', {
    staticClass: "row measurement-graph-row push"
  }, [(_vm.flagDisplayChannelJournal) ? _c('div', {
    staticClass: "row"
  }, [(_vm.thisChannelAsDeviceFlag) ? _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('multiple-graph', {
    attrs: {
      "channelIndex": _vm.channelIndex
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('channel-journal', {
    attrs: {
      "channelIndex": _vm.channelIndex
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button ",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.flagDisplayChannelJournal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt fa-1x"
  }), _vm._v(" " + _vm._s(_vm.buttonLabelHideJournal[_vm.actualLanguage]))])])])]) : _c('div', {
    staticClass: "row"
  }, [(_vm.thisChannelAsDeviceFlag) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('multiple-graph', {
    attrs: {
      "channelIndex": _vm.channelIndex
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundleIsDefaultBundle == false) ? _c('div', {
    staticClass: "col-sm-12 col-md-12 push"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button ",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.flagDisplayChannelJournal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt fa-1x"
  }), _vm._v(" " + _vm._s(_vm.buttonLabelShowJournal[_vm.actualLanguage]))])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  })]) : _vm._e()])])])], 1) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed61d994","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/measurements/DisplayChannel.vue
// module id = 1592
// module chunks = 4